import { useErrorBoundary } from "react-error-boundary";
import { useParams } from "react-router";

import { TagsType, api, useApiV1AssessmentsAssessmentsProtocolQuestionsListQuery } from "@/services/api";
import { useAppDispatch } from "@/services/store";
import { Menu, TaskComparisonViewParams } from "./types";
import { adaptAvailableProtocolQuestionsSubThemeReadIntoMenu } from "./utils";

export const getQuestionsFromGroups = (groups?: Menu[]) =>
  groups?.flatMap(group => group.sub_groups.flatMap(sub_group => sub_group.questions)) ?? [];

export const useGetData = () => {
  const { assessmentId } = useParams<TaskComparisonViewParams>();
  const { showBoundary } = useErrorBoundary();
  const dispatch = useAppDispatch();

  const {
    data: themes,
    isLoading: themesAreLoading,
    error: themesError,
  } = useApiV1AssessmentsAssessmentsProtocolQuestionsListQuery(
    {
      assessmentId: assessmentId!,
    },
    { skip: !assessmentId },
  );

  const errors = [themesError].filter(e => !!e);

  if (errors.length > 0) {
    showBoundary({
      errors,
      refetch: () => {
        const tags = [themesError && "Tasks"].filter(tag => tag !== undefined) as TagsType[];
        dispatch(api.util.invalidateTags(tags));
      },
    });
  }
  const menuList = adaptAvailableProtocolQuestionsSubThemeReadIntoMenu(themes ?? []);
  return {
    questions: getQuestionsFromGroups(menuList),
    themes,
    menuList,
    isLoading: themesAreLoading,
  };
};
